// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__HwJN6","footer":"ModalCreateQualiphyProcedure_footer__qO90D","additionData":"ModalCreateQualiphyProcedure_additionData__2ixgk"};